import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    TableRow,
    TableRowColumn
} from 'material-ui/Table';
import FuseTheme from '../global/theme';
import IconButton from 'material-ui/IconButton';
import IconRemove from 'material-ui/svg-icons/action/delete';

/**
 * A component for creating a named item with optional removal.
 * Loaded by DiscountConditionTables.
 *
 */
class DiscountConditionTableRow extends Component {

    handleRemoveClick = () => {
        this.props.onRemoveClick(this.props.type, this.props.id);
    };

    render() {
        const {
            id,
            name,
        } = this.props;

        const styles = {
            block: {display: 'block'},
            row: {height: '40px'},
            alignTop: {verticalAlign: 'top'},
            icon: {height: '40px', padding: '10px', overflow: 'inherit'},
            fieldSmall: {display: 'inline-block', maxWidth: 100, maxHeight: 62},
        };
        return (
            <TableRow style={styles.row}>
                <TableRowColumn className={'row-discount-condition-name-' + id} style={styles.row}>
                    <span>{id}</span>
                </TableRowColumn>
                <TableRowColumn className={'row-discount-condition-name-' + id} style={styles.row}>
                    <span>{name}</span>
                </TableRowColumn>

                <TableRowColumn style={styles.row}>
                    <IconButton style={styles.icon} onClick={(e) => this.handleRemoveClick(e)}>
                        <IconRemove color={FuseTheme.palette.primary1Color}/>
                    </IconButton>
                </TableRowColumn>
            </TableRow>
        )
    }
}

DiscountConditionTableRow.propTypes = {
    addField: PropTypes.bool,
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    onRemoveClick: PropTypes.func,
    type: PropTypes.string.isRequired
};

DiscountConditionTableRow.defaultProps = {
    addField: true,
    id: '',
    name: '',
    style: {padding: 0},
};

export default DiscountConditionTableRow;



// WEBPACK FOOTER //
// ./src/Fuse/components/DiscountConditionTableRow.js